<template>
  <v-container>
    <v-row class="justify-space-around align-center mb-2 mt-1">
      <v-label>Showing: {{ selectedEventName }}</v-label
      ><v-btn @click="getpositions" rounded small
        ><v-icon small>mdi-refresh</v-icon>REFRESH</v-btn
      >
    </v-row>
    <!-- <v-banner></v-banner> -->
    <!-- <v-btn @click="toggleMapStyle">Toggle map height</v-btn> -->
    <ul v-if="errors && errors.length">
      <li v-for="error of errors" :key="error.id" style="color: Red">
        {{ error.message }}
      </li>
    </ul>
    <v-img height="100%" width="100%">
      <l-map
        :zoom.sync="zoom"
        :options="mapOptions"
        :center="center"
        :min-zoom="minZoom"
        :max-zoom="maxZoom"
        @update:center="centerUpdate"
        :style="mapstyle"
      >
        <l-control-layers
          :position="layersPosition"
          :collapsed="true"
          :sort-layers="true"
        />
        <l-tile-layer
          v-for="tileProvider in tileProviders"
          :key="tileProvider.name"
          :name="tileProvider.name"
          :visible="tileProvider.visible"
          :url="tileProvider.url"
          :attribution="tileProvider.attribution"
          :token="token"
          layer-type="base"
        />
        <l-control-zoom :position="zoomPosition" />
        <v-locatecontrol />
        <l-control-attribution
          :position="attributionPosition"
          :prefix="attributionPrefix"
        />
        <l-control-scale :imperial="imperial" />
        <l-marker
          :visible="mymarker.visible"
          :draggable="mymarker.draggable"
          :lat-lng.sync="mymarker.position"
          :icon="mymarker.icon"
        >
          <l-popup :content="mymarker.popuptext"></l-popup>
          <!-- <l-tooltip :content="mymarker.tooltip" /> -->
        </l-marker>
        <!-- <l-circle-marker
          v-for="marker in markers"
          :key="marker.id"
          :lat-lng="marker.center"
          :radius="marker.radius"
          :color="marker.color"
        >
          <l-popup :content="marker.tooltip" />
          <l-tooltip :content="marker.tooltip" />
        </l-circle-marker> -->
        <l-layer-group
          v-for="item in stuff"
          :key="item.id"
          :visible.sync="item.visible"
          layer-type="overlay"
          name="Pilots"
        >
          <l-layer-group :visible="item.markersVisible">
            <l-circle-marker
              v-for="marker in markers"
              :key="marker.id"
              :lat-lng="marker.center"
              :radius="marker.radius"
              :color="marker.color"
            >
              <l-popup :content="marker.tooltip" />
              <!-- <l-tooltip :content="marker.tooltip" /> -->
            </l-circle-marker>
          </l-layer-group>
        </l-layer-group>
      </l-map>
    </v-img>
    <v-card>
      <v-card-title>
        Pilots
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="pilotpositions"
        :search="search"
        dense
        :loading="loading"
        loading-text="Loading... Please wait"
      >
        <template v-slot:item="{ item }">
          <v-col :class="`d-flex justify-center`">
            <v-btn
              :color="item.StatusColor"
              dark
              min-width="100"
              :class="`d-flex justify-space-around mb-4`"
              @click="pilotFocus(item)"
              :outlined="item.outlined"
              small
              >Select {{ item.tooltip }}</v-btn
            >
          </v-col>
        </template>
      </v-data-table>
      <!-- <ul v-if="errors && errors.length">
            <li v-for="error of errors" :key="error.id" style="color:Red;">{{error.message}}</li>
      </ul>-->
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { latLngBounds } from "leaflet";
import { latLng } from "leaflet";
// import Vue2LeafletLocatecontrol from 'vue2-leaflet-locatecontrol';
import Vue2LeafletLocatecontrol from "vue2-leaflet-locatecontrol/Vue2LeafletLocatecontrol";
import {
  LMap,
  LTileLayer,
  LMarker,
  //   LPolyline,
  LLayerGroup,
  // LTooltip,
  LPopup,
  LControlZoom,
  LControlAttribution,
  LControlScale,
  LControlLayers,
  LCircleMarker,
} from "vue2-leaflet";

const markers1 = [
  //   {
  //     position: { lng: -1.219482, lat: 47.41322 },
  //     visible: true,
  //     draggable: true
  //   },
  //   { position: { lng: -1.571045, lat: 47.457809 } },
  //   { position: { lng: -1.560059, lat: 47.739323 } },
];

const poly1 = [
  //   { lng: -1.219482, lat: 47.41322 },
  //   { lng: -1.571045, lat: 47.457809 },
  //   { lng: -1.560059, lat: 47.739323 },
  //   { lng: -1.219482, lat: 47.41322 }
];

const tileProviders = [
  {
    name: "OpenStreetMap",
    visible: false,
    attribution:
      '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  },
  {
    name: "OpenTopoMap",
    visible: true,
    url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
    attribution:
      'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
  },
];

export default {
  name: "Map",
  props: {
    eventId: {
      type: String,
    },
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    // LPolyline,
    LLayerGroup,
    // LTooltip,
    LPopup,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    LControlLayers,
    LCircleMarker,
    "v-locatecontrol": Vue2LeafletLocatecontrol,
  },
  data() {
    return {
      //   initialLocation: [59.93428, 30.335098],
      selectedEventName: null,
      keys: ["position", "tooltip"],
      //   center: [59.504, 9.9969],
      center: latLng(59.504, 9.9969),
      currentCenter: latLng(59.504, 9.9969),
      opacity: 0.6,
      token: "your token if using mapbox",
      mapOptions: {
        zoomControl: false,
        attributionControl: false,
        zoomSnap: true,
      },
      zoom: 6,
      minZoom: 1,
      maxZoom: 20,
      zoomPosition: "topleft",
      attributionPosition: "bottomright",
      layersPosition: "topright",
      attributionPrefix: "Vue2Leaflet",
      imperial: false,
      Positions: ["topleft", "topright", "bottomleft", "bottomright"],
      tileProviders: tileProviders,
      pilotpositions: [],
      errors: [],
      mymarker: [
        {
          // position = this.currentCenter,
          id: "mymarker",
          position: { lat: 59.49, lng: 9.9969 },
          draggable: false,
          visible: true,
          tooltip: "Selected",
        },
      ],
      search: "",
      loading: true,
      mapstyletoggle: 1000,
      mapstyle: "height: 1000px; width: 100%; z-index: 0",
      headers: [{ text: "", value: "tooltip" }],
      markers: [
        // {
        //   id: "m1",
        //   tooltip: "Grøtterud",
        //   center: { lat: 59.504, lng: 9.9969 },
      ],
      polylines: [
        {
          id: "p1",
          points: [
            { lat: 37.772, lng: -122.214 },
            { lat: 21.291, lng: -157.821 },
            { lat: -18.142, lng: -181.569 },
            { lat: -27.467, lng: -206.973 },
          ],
          visible: true,
        },
        {
          id: "p2",
          points: [
            [-73.91, 40.78],
            [-87.62, 41.83],
            [-96.72, 32.76],
          ],
          visible: true,
        },
      ],
      stuff: [
        {
          id: "s1",
          markers: markers1,
          polyline: { points: poly1, visible: true },
          visible: true,
          markersVisible: true,
        },
      ],
      //   bounds: latLngBounds(
      //     { lat: 51.476483373501964, lng: -0.14668464136775586 },
      //     { lat: 51.52948330894063, lng: -0.019140238291583955 }
      //   )
    };
  },
  methods: {
    toggleMapStyle() {
      if (this.mapstyletoggle == 1000) {
        this.mapstyle = "height: 500px; width: 100%; z-index: 0";
        this.mapstyletoggle = 500;
      } else {
        this.mapstyle = "height: 1000px; width: 100%; z-index: 0";
        this.mapstyletoggle = 1000;
      }
    },
    alert(item) {
      alert("this is " + JSON.stringify(item));
    },
    addMarker: function () {
      var clat = this.currentCenter.lat;
      var clng = this.currentCenter.lng;
      console.log(clat + "/" + clng);
      const newMarker = {
        // position = this.currentCenter,
        position: { lat: clat, lng: clng },
        draggable: true,
        visible: true,
        tooltip: "You",
      };
      //   this.markers.push(newMarker);
      this.mymarker = newMarker;
    },
    removeMarker: function (index) {
      this.markers.splice(index, 1);
    },
    removeAllMarkers() {
      var array = this.markers;
      array.forEach((element) => {
        element.tooltip = "";
        this.markers.pop();
      });
    },
    removeMyMarker: function () {
      this.mymarker.tooltip = "";
      this.mymarker.position = { lat: 0, lng: 0 };
      this.mymarker.visible = false;
    },
    fitPolyline: function () {
      const bounds = latLngBounds(markers1.map((o) => o.position));
      this.bounds = bounds;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    pilotFocus(pilot) {
      var clat = pilot.lat;
      var clng = pilot.lon;
      this.currentCenter.lat = clat;
      this.currentCenter.lng = clng;
      //   this.zoom = 12;
      this.center = this.currentCenter;
      this.mymarker.position = { lat: clat, lng: clng };
      this.mymarker.visible = true;
      this.mymarker.tooltip = pilot.Name;

      //   console.log(pilot)
      //   console.log(this.currentCenter)
    },
    helpMe() {
      alert("Sorry, no help implemented yet! :)");
    },
    submit() {
      var regId = this.pid;
      var ac = this.ac;
      var lat = this.mymarker.position.lat;
      var lon = this.mymarker.position.lng;
      var comment = this.comment;
      if (comment === null) {
        comment = "";
      }
      var toSubmit = JSON.stringify({ regId, ac, lat, lon, comment });
      const uri = this.baseUrl + "setpilotposition/" + regId;
      //   console.log(uri)
      console.log(toSubmit);
      this.sendpost(uri, toSubmit, 1);
    },
    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
          if (this.statusResult == 1) {
            this.isValid = false;
            this.removeAllMarkers();
            this.getpositions();
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },
    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    getpositions() {
      if (this.eventId == null) {
        this.eventId = 0;
      }
      this.markers = [];

      axios
        // .get("http://jsonplaceholder.typicode.com/posts")
        // .get('http://localhost:3000/pilotlist')
        .get(this.baseUrl + "getpositions/" + this.eventId)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.pilotpositions = response.data;
          // console.log(this.pilotpositions);
          this.center = {
            lat: this.pilotpositions[0].lat,
            lng: this.pilotpositions[0].lon,
          };
          this.selectedEventName = this.pilotpositions[0].SelectedEventName;

          var array = this.pilotpositions;
          console.log("array", array);
          array.forEach((element) => {
            const newCircleMarker = {
              // id: element.id,https://maps.google.com/maps?q=61.8339,9.2722&z=10
              tooltip:
                element.tooltip +
                "</br>" +
                element.MID +
                "</br></br><b><a href='https://maps.google.com/maps?q=" +
                element.lat +
                "," +
                element.lon +
                "&z=10' target='_blank'>Open in Google Maps</a></b></br></br><b><a href='tel:" +
                element.MID +
                "'>Call</a>&nbsp;&nbsp;&nbsp;&nbsp;<b><a href='sms:" +
                element.MID +
                "'>SMS</a></b>",

              // popuptext: element.tooltip + "</br>",
              center: { lat: element.lat, lng: element.lon },
              radius: element.radius,
              color: element.color,
              visible: true,
            };
            // console.log(newCircleMarker);
            this.markers.push(newCircleMarker);
          });
          // console.log(this.markers);
          this.loading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    // this.pid = 1;
    this.pid = this.$route.params.id;
    if (this.pid === undefined) {
      this.pid = 0;
      // this.showessentials = false;
    }
    this.mymarker.tooltip = "";
    this.mymarker.position = { lat: 0, lng: 0 };
    this.mymarker.visible = false;
    this.getpositions();
    // this.center = { lat: this.pilotpositions[0].lat, lng: this.pilotpositions[0].lon };
    // console.log(this.center)
  },
  //   mounted() {
  //     this.$nextTick(() => {
  //       this.$refs.myMap.mapObject.ANY_LEAFLET_MAP_METHOD();
  //     });
  //   }
};
</script>

<style>
/* @import "~leaflet/dist/leaflet.css"; */
/* @import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"; */
/* html,
body {
  height: 100%;
  margin: 0;
} */
</style>